import React from "react";
import { Col, Row } from "antd";
// import AdminSignupForm from "../Components/Onboarding//adminSignupForm";
import { css } from "emotion";
import ContactUsPopup from "./ContactUsPopup";
import AdminSignupForm from "../Components/Onboarding/Invoice/adminSignupForm";

function SignupInvoice() {
  return (
    <>
      <div
        className={css`
          // width: 100vw;
          // height: 100vh;
          background: radial-gradient(
            circle at top,
            #815b72 3%,
            #2e1420 60%,
            #260a2f 109%
          );
          // position: fixed;
          // top: 0;
          // left: 0;
        `}
        style={{
          backgroundImage: `url("/pics/login/login_background.jpg")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          minHeight: "100vh",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row
          style={{
            width: "100%",
            display: "flex",
            margin: "40px 0",
            alignItems: " center",
            justifyContent: "center",
          }}
        >
          <Col span={20}>
            <AdminSignupForm />
          </Col>
        </Row>
      </div>{" "}
      {/* <ContactUsPopup /> */}
    </>
  );
}

export default SignupInvoice;
